import { useInternalHost } from '../internal';
import type { Metadata } from '../xinglet';

export function useMetadata(name: string): Metadata {
  return useInternalHost().runtime.metadataMap[name];
}
